var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccessDone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "198px",
    height: "198px",
    viewBox: "0 0 198 198",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "51DC410B-35BC-4506-A905-629892143FC5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.7.1.11-Onboarding---Organisational-Chart---Position-Details---Editing-Fields---Duplicate-Success",
    transform: "translate(-621.000000, -171.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(623.000000, 173.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "motivation",
    transform: "translate(65.000000, 65.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8666667,28.6315789 L45.8666667,22.9311741 L45.8666667,15.6761134 C45.8666667,13.6757895 44.192,12.048583 42.1333333,12.048583 C41.4805333,12.048583 40.8768,12.2268502 40.3424,12.5129069 C39.8624,11.0473846 38.4650667,9.9757085 36.8,9.9757085 C36.1472,9.9757085 35.5434667,10.1539757 35.0090667,10.4400324 C34.5290667,8.97451012 33.1317333,7.90283401 31.4666667,7.90283401 C29.8016,7.90283401 28.4042667,8.97451012 27.9242667,10.4400324 C27.3898667,10.1539757 26.7861333,9.9757085 26.1333333,9.9757085 C24.0746667,9.9757085 22.4,11.602915 22.4,13.6032389 L22.4,15.2625749 C19.9690667,15.7445182 18.1333333,17.837085 18.1333333,20.340081 L18.1333333,28.6315789 C18.1333333,32.2145425 20.2037333,35.4223158 23.4666667,36.9894089 L23.4666667,42.1052632 L22.4,42.1052632 C21.8101333,42.1052632 21.3333333,42.569587 21.3333333,43.1417004 L21.3333333,62.8340081 C21.3333333,63.4061215 21.8101333,63.8704453 22.4,63.8704453 L41.6,63.8704453 C42.1898667,63.8704453 42.6666667,63.4061215 42.6666667,62.8340081 L42.6666667,43.1417004 C42.6666667,42.569587 42.1898667,42.1052632 41.6,42.1052632 L40.5333333,42.1052632 L40.5333333,36.9904453 C43.7962667,35.4223158 45.8666667,32.2145425 45.8666667,28.6315789 Z M42.1333333,14.1214575 C43.0154667,14.1214575 43.7333333,14.8189798 43.7333333,15.6761134 L43.7333333,22.9311741 C43.7333333,23.7883077 43.0154667,24.48583 42.1333333,24.48583 C41.2512,24.48583 40.5333333,23.7883077 40.5333333,22.9311741 L40.5333333,15.6761134 C40.5333333,14.8189798 41.2512,14.1214575 42.1333333,14.1214575 Z M36.8,12.048583 C37.6821333,12.048583 38.4,12.7461053 38.4,13.6032389 L38.4,15.6761134 L38.4,22.9311741 C38.4,23.7883077 37.6821333,24.48583 36.8,24.48583 C35.9178667,24.48583 35.2,23.7883077 35.2,22.9311741 L35.2,13.6032389 C35.2,12.7461053 35.9178667,12.048583 36.8,12.048583 Z M29.8666667,11.5303644 C29.8666667,10.6732308 30.5845333,9.9757085 31.4666667,9.9757085 C32.3488,9.9757085 33.0666667,10.6732308 33.0666667,11.5303644 L33.0666667,13.6032389 L33.0666667,22.9311741 C33.0666667,23.7883077 32.3488,24.48583 31.4666667,24.48583 C30.5845333,24.48583 29.8666667,23.7883077 29.8666667,22.9311741 L29.8666667,22.049166 C31.1232,21.4646154 32,20.2271093 32,18.7854251 C32,17.3437409 31.1232,16.1062348 29.8666667,15.5216842 L29.8666667,13.6032389 L29.8666667,11.5303644 Z M27.7333333,22.9311741 C27.7333333,23.7883077 27.0154667,24.48583 26.1333333,24.48583 C25.9488,24.48583 25.7696,24.4516275 25.6,24.3925506 L25.6,22.4129555 L27.7333333,22.4129555 L27.7333333,22.9311741 Z M26.1333333,12.048583 C27.0154667,12.048583 27.7333333,12.7461053 27.7333333,13.6032389 L27.7333333,15.1578947 L24.5333333,15.1578947 L24.5333333,13.6032389 C24.5333333,12.7461053 25.2512,12.048583 26.1333333,12.048583 Z M40.5333333,44.1781377 L40.5333333,46.2510121 L23.4666667,46.2510121 L23.4666667,44.1781377 L40.5333333,44.1781377 Z M23.4666667,61.7975709 L23.4666667,48.3238866 L40.5333333,48.3238866 L40.5333333,61.7975709 L23.4666667,61.7975709 Z M25.6,42.1052632 L25.6,36.3198704 C25.6,35.8980405 25.3365333,35.517668 24.9333333,35.3590931 C22.0992,34.2449231 20.2666667,31.6030445 20.2666667,28.6315789 L20.2666667,20.340081 C20.2666667,18.6258138 21.7024,17.2307692 23.4666667,17.2307692 L28.2666667,17.2307692 C29.1488,17.2307692 29.8666667,17.9282915 29.8666667,18.7854251 C29.8666667,19.6425587 29.1488,20.340081 28.2666667,20.340081 L24.5333333,20.340081 C23.9434667,20.340081 23.4666667,20.8044049 23.4666667,21.3765182 L23.4666667,27.5951417 C23.4666667,28.1672551 23.9434667,28.6315789 24.5333333,28.6315789 C27.4741333,28.6315789 29.8666667,30.9563077 29.8666667,33.8137652 L32,33.8137652 C32,30.1644696 29.2138667,27.1370364 25.6,26.6322915 L25.6,26.517247 C25.776,26.541085 25.9530667,26.5587045 26.1333333,26.5587045 C27.1786667,26.5587045 28.1216,26.1368745 28.8,25.4621538 C29.4784,26.1368745 30.4213333,26.5587045 31.4666667,26.5587045 C32.512,26.5587045 33.4549333,26.1368745 34.1333333,25.4621538 C34.8117333,26.1368745 35.7546667,26.5587045 36.8,26.5587045 C37.8453333,26.5587045 38.7882667,26.1368745 39.4666667,25.4621538 C40.1450667,26.1368745 41.088,26.5587045 42.1333333,26.5587045 C42.7082667,26.5587045 43.2469333,26.4208583 43.7333333,26.194915 L43.7333333,28.6315789 C43.7333333,31.604081 41.9008,34.2449231 39.0666667,35.3590931 C38.6634667,35.517668 38.4,35.8980405 38.4,36.3198704 L38.4,42.1052632 L25.6,42.1052632 Z",
    id: "Shape",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6,31.7408907 L11.7333333,31.7408907 C11.7333333,23.940664 8.8608,16.6026883 3.64373333,11.0784777 L2.9184,10.3115142 L1.3472,11.7138138 L2.07146667,12.4807773 C6.85653333,17.5468826 9.6,24.5666721 9.6,31.7408907 Z",
    id: "Path",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9274667,12.4807773 L62.6528,11.7138138 L61.0816,10.3115142 L60.3552,11.0784777 C55.1392,16.6026883 52.2666667,23.940664 52.2666667,31.7408907 L54.4,31.7408907 C54.4,24.5666721 57.1434667,17.5468826 61.9274667,12.4807773 L61.9274667,12.4807773 Z",
    id: "Path",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,19.4777652 C16,13.4913036 18.2336,7.6354332 22.128,3.41298785 L20.5386667,2.02934413 C16.2368,6.69538462 13.8666667,12.8922429 13.8666667,19.4777652 L13.8666667,20.340081 L16,20.340081 L16,19.4777652 Z",
    id: "Path",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,20.340081 L50.1333333,20.340081 L50.1333333,19.4777652 C50.1333333,12.8922429 47.7632,6.69538462 43.4613333,2.02934413 L41.872,3.41298785 C45.7664,7.6354332 48,13.4913036 48,19.4777652 L48,20.340081 Z",
    id: "Path",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6,17.2307692 L11.7333333,17.2307692 L11.7333333,16.8193036 C11.7333333,10.7696194 9.8208,4.96868016 6.20053333,0.0456032389 L4.46613333,1.24994332 C7.824,5.81959514 9.6,11.2038866 9.6,16.8193036 L9.6,17.2307692 Z",
    id: "Path",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4,16.8193036 C54.4,11.2038866 56.176,5.82063158 59.5338667,1.25097976 L57.7984,0.0466396761 C54.1792,4.96868016 52.2666667,10.768583 52.2666667,16.8193036 L52.2666667,17.2307692 L54.4,17.2307692 L54.4,16.8193036 Z",
    id: "Path",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4A4A4A",
    points: "2.13333333 22.4129555 4.26666667 22.4129555 4.26666667 24.48583 2.13333333 24.48583"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4A4A4A",
    points: "4.26666667 24.48583 6.4 24.48583 6.4 26.5587045 4.26666667 26.5587045"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4A4A4A",
    points: "2.13333333 26.5587045 4.26666667 26.5587045 4.26666667 28.6315789 2.13333333 28.6315789"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4A4A4A",
    points: "0 24.48583 2.13333333 24.48583 2.13333333 26.5587045 0 26.5587045"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4A4A4A",
    points: "59.7333333 22.4129555 61.8666667 22.4129555 61.8666667 24.48583 59.7333333 24.48583"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4A4A4A",
    points: "61.8666667 24.48583 64 24.48583 64 26.5587045 61.8666667 26.5587045"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4A4A4A",
    points: "59.7333333 26.5587045 61.8666667 26.5587045 61.8666667 28.6315789 59.7333333 28.6315789"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4A4A4A",
    points: "57.6 24.48583 59.7333333 24.48583 59.7333333 26.5587045 57.6 26.5587045"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4A4A4A",
    points: "48 32.7773279 50.1333333 32.7773279 50.1333333 34.8502024 48 34.8502024"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4A4A4A",
    points: "50.1333333 34.8502024 52.2666667 34.8502024 52.2666667 36.9230769 50.1333333 36.9230769"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4A4A4A",
    points: "48 36.9230769 50.1333333 36.9230769 50.1333333 38.9959514 48 38.9959514"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4A4A4A",
    points: "45.8666667 34.8502024 48 34.8502024 48 36.9230769 45.8666667 36.9230769"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4A4A4A",
    points: "13.8666667 32.7773279 16 32.7773279 16 34.8502024 13.8666667 34.8502024"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4A4A4A",
    points: "16 34.8502024 18.1333333 34.8502024 18.1333333 36.9230769 16 36.9230769"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4A4A4A",
    points: "13.8666667 36.9230769 16 36.9230769 16 38.9959514 13.8666667 38.9959514"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4A4A4A",
    points: "11.7333333 34.8502024 13.8666667 34.8502024 13.8666667 36.9230769 11.7333333 36.9230769"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4A4A4A",
    points: "35.2 2.72064777 37.3333333 2.72064777 37.3333333 4.79352227 35.2 4.79352227"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4A4A4A",
    points: "23.4666667 4.79352227 25.6 4.79352227 25.6 6.86639676 23.4666667 6.86639676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41653333,40.8169717 C6.78293333,43.3759352 5.33333333,46.7775223 5.33333333,50.3967611 L7.46666667,50.3967611 C7.46666667,47.3309798 8.6944,44.4496842 10.9248,42.2835304 L11.4208,41.8026235 L9.91253333,40.3360648 L9.41653333,40.8169717 Z",
    id: "Path",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0874667,40.3350283 L52.5792,41.801587 L53.0752,42.2824939 C55.3056,44.4496842 56.5333333,47.3309798 56.5333333,50.3967611 L58.6666667,50.3967611 C58.6666667,46.7775223 57.2170667,43.3759352 54.5834667,40.8169717 L54.0874667,40.3350283 Z",
    id: "Path",
    fill: "#D2D2D2"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M97,157 C130.137085,157 157,130.137085 157,97 C157,63.862915 130.137085,37 97,37 C63.862915,37 37,63.862915 37,97",
    id: "Oval",
    stroke: "#4A4A4A",
    strokeWidth: 3,
    strokeLinecap: "round",
    transform: "translate(97.000000, 97.000000) rotate(-180.000000) translate(-97.000000, -97.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,176 C140.630495,176 176,140.630495 176,97 C176,53.3695048 140.630495,18 97,18 C53.3695048,18 18,53.3695048 18,97",
    id: "Oval",
    stroke: "#F1F1F1",
    strokeWidth: 3,
    strokeLinecap: "round",
    transform: "translate(97.000000, 97.000000) rotate(-345.000000) translate(-97.000000, -97.000000) "
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccessDone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/successDone.35168e5c8edfa30d665e56ecbaf857dd.svg";